module.exports = __webpack_public_path__ + "static/fonts/355CC9_2_0.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/355CC9_2_0.woff
// module id = 150
// module chunks = 0